;(function ( $ ) {

    /**
     *  hamburgerMenu
     *  Menu for small devices
     **/

    'use strict';

    // Create the defaults once
    var pluginName = 'hamburgerMenu';
    var defaults = {};

    // The actual plugin constructor
    function Plugin ( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options );
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        init: function () {
            this.registerEvents();
        },

        registerEvents: function() {
            var _this = this;
            $(this.element).on('click', function() {
                if ($(this).hasClass('is-active')) {
                    $(this).removeClass('is-active');
                    $(this).css('z-index', '1');
                    $('#mobile-navigation').removeClass('is-active');
                    $('body').removeClass('noscroll');
                }   else {
                    $(this).addClass('is-active');
                    _this.renderMobileNavigation();
                    $(this).css('z-index', '9999');
                    $('#mobile-navigation').addClass('is-active');
                    $('#mobile-navigation').css('z-index', '9998');
                    $('body').addClass('noscroll');
                }
            });
        },

        renderMobileNavigation: function() {
            var $nav;
            if ($('#mobile-navigation').length) {
                $nav = $('#mobile-navigation');
            } else {
                $nav = $('<div class="mobile-navigation bg-color-event" id="mobile-navigation"></div>');
                $('.atp-header').after($nav);
                $nav.empty();
                if ($('.atp-header-event .event-signature').length) {
                    var $signature = $('.atp-header-event .event-signature').clone();
                    $nav.append($signature);
                }
                if ($('.atp-header-event .event-booth').length) {
                    var $booth = $('.atp-header-event .event-booth').clone();
                    $nav.append($booth);
                }
                if ($('.atp-header-event .event-tabs').length) {
                    var $tabs = $('.atp-header-event .event-tabs').clone();
                    $nav.append($tabs);
                }
                if ($('.atp-header .atp-primary-navigation').length) {
                    var $primaryNav = $('.atp-header .atp-primary-navigation').clone();
                    $primaryNav.find('.select2-container').remove();
                    $primaryNav.find('select')
                        .removeClass('select2 select2-hidden-accessible')
                        .show();
                    $nav.append($primaryNav);
                    $nav.find('.submit-on-change').submitOnChange();
                }
            }
        }
    });

    $.fn[ pluginName ] = function ( options ) {
        return this.each(function() {
            if ( !$.data( this, 'plugin_' + pluginName ) ) {
                $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
            }
        });
    };
})( jQuery );
